var render, staticRenderFns
import script from "./baseView.vue?vue&type=script&lang=js&"
export * from "./baseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4854a9b7",
  null
  
)

export default component.exports